"use strict";

var _ColorPicker = require("./components/ColorPicker");

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _ColorPicker2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-colorpicker/lib/index.js
// module id = 269
// module chunks = 0 1